"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "阶段名称",
        prop: "stageName",
        isShow: true,
        width: "100"
      },
      // {
      //   name: "所属项目",
      //   prop: "matchId",
      //   isShow: true,
      //   width: "150",
      //   isFormats: true
      // },
      {
        name: "开始时间",
        prop: "beginTime",
        isShow: true,
        width: "150"
      }, {
        name: "结束时间",
        prop: "endTime",
        isShow: true,
        width: "150"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      checkBoxs: []
    };
  },
  methods: {
    // 获取当前项目下的阶段列表
    getStageList: function getStageList() {
      var _this = this;
      (0, _project.stageAllList)({
        name: this.queryValue,
        matchId: this.$route.query.matchId,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 新增
    save: function save() {
      this.$router.push({
        path: "/object/objectStageSetAdd",
        query: {
          matchId: this.$route.query.matchId
        }
      });
    },
    // 编辑
    edit: function edit(e) {
      this.$router.push({
        path: "/object/objectStageSetEdit",
        query: {
          id: e.id,
          matchId: e.matchId
        }
      });
    },
    // 删除
    deleteItem: function deleteItem(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.stageDel)({
          idList: id
        }).then(function () {
          _this2.getStageList();
          _this2.$message.success("操作成功。");
        });
      }).catch(function () {
        _this2.$message.info("取消删除。");
      });
    },
    // 模糊查找
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getStageList();
    },
    // 项目组别
    matchGroup: function matchGroup(e) {
      this.$router.push({
        path: "/object/objectStageSetAndGroupSet",
        query: {
          id: e.id,
          matchId: e.matchId
        }
      });
    },
    // 专家分配和频分规则
    expertSign: function expertSign(row) {
      this.$router.push({
        path: "/object/expertGrade",
        query: {
          stageId: row.id
        }
      });
    },
    // 专家管理
    stageExpert: function stageExpert(e) {
      this.$router.push({
        path: "/object/objectTechnocracy",
        query: {
          stageId: e.id
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this3 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getStageList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getStageList();
    }
  },
  created: function created() {
    this.getStageList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};